<template>
  <v-container>
    <v-row>
      <v-col cols="12" class="d-flex justify-center flex-column ga-4">
        <div class="justify-center flex-grow-0">
          <!-- <div class="mb-6" style="text-align: center">
            <img src="@/assets/logo.svg" width="200" />
          </div> -->
        </div>
        <ChangePasswordForm
          :is-active="undefined"
          :use-token="true"
          :enter-password="false"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
.v-container {
  height: 100%;
  max-width: 30rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
